import styled, { keyframes } from "styled-components";
import { FaAngular, FaReact, FaWordpress } from "react-icons/fa";
import { SiNodedotjs, SiMongodb, SiElementor } from "react-icons/si";

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const SkillsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 6px;
`;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: 30px;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.4px;
  border: 1.5px solid ${({ color }) => color};
  color: #fff;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(6px);
  opacity: 0;
  animation: ${fadeInUp} 0.55s ease forwards;
  animation-delay: ${({ delay }) => delay};

  .icons {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 1.05em;
    color: ${({ color }) => color};
  }
`;

const skills = [
  {
    label: "MERN Stack",
    color: "#68A063",
    delay: "0.1s",
    icons: [<FaReact key="r" />, <SiNodedotjs key="n" />, <SiMongodb key="m" />],
  },
  {
    label: "Angular",
    color: "#dd1b16",
    delay: "0.3s",
    icons: [<FaAngular key="a" />],
  },
  {
    label: "WordPress",
    color: "#21759b",
    delay: "0.5s",
    icons: [<FaWordpress key="w" />, <SiElementor key="e" />],
  },
];

function Type() {
  return (
    <SkillsWrapper>
      {skills.map(({ label, color, delay, icons }) => (
        <Badge key={label} color={color} delay={delay}>
          <span className="icons">{icons}</span>
          {label}
        </Badge>
      ))}
    </SkillsWrapper>
  );
}

export default Type;
